import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Chip, Box, Typography } from "@mui/material";
import {
  CheckCircleOutline as PaidIcon,
  AccessTime as PendingIcon,
  TrendingUp as PartialIcon,
} from "@mui/icons-material";

const columns = [
  { field: "policy", headerName: "Policy Number", width: 140 },
  { field: "customer", headerName: "Customer", width: 140 },
  { field: "type", headerName: "Policy Type", width: 160 },
  {
    field: "premium",
    headerName: "Premium",
    width: 120,
    renderCell: (params) => (
      <Typography sx={{ fontWeight: 500 }}>{params.value}</Typography>
    ),
  },
  {
    field: "commission",
    headerName: "Commission",
    width: 120,
    renderCell: (params) => (
      <Typography sx={{ fontWeight: 500 }}>{params.value}</Typography>
    ),
  },
  { field: "rate", headerName: "Rate", width: 100 },
  {
    field: "status",
    headerName: "Status",
    width: 120,
    renderCell: (params) => {
      const map = {
        Paid: { color: "success.main", label: "Paid", Icon: PaidIcon },
        Pending: { color: "warning.main", label: "Pending", Icon: PendingIcon },
        Partial: { color: "info.main", label: "Partial", Icon: PartialIcon },
      };
      const { color, label, Icon } = map[params.value];
      return (
        <Chip
          icon={<Icon />}
          label={label}
          size="small"
          sx={{ backgroundColor: `${color}20`, color }}
        />
      );
    },
  },
  { field: "date", headerName: "Payout Date", width: 120 },
  {
    field: "remaining",
    headerName: "Remaining",
    width: 120,
    renderCell: (params) => (
      <Typography
        sx={{
          fontWeight: 500,
          color: params.value === "-" ? "text.secondary" : "error.main",
        }}
      >
        {params.value}
      </Typography>
    ),
  },
];

const rows = [
  {
    id: 1,
    policy: "POL001234",
    customer: "John Doe",
    type: "Health Insurance",
    premium: "₹15,000.00",
    commission: "₹1,500.00",
    rate: "10%",
    status: "Paid",
    date: "1/15/2024",
    remaining: "-",
  },
  {
    id: 2,
    policy: "POL001235",
    customer: "Jane Smith",
    type: "Life Insurance",
    premium: "₹25,000.00",
    commission: "₹2,500.00",
    rate: "10%",
    status: "Pending",
    date: "2/1/2024",
    remaining: "₹2,500.00",
  },
  {
    id: 3,
    policy: "POL001236",
    customer: "Bob Johnson",
    type: "Motor Insurance",
    premium: "₹8,000.00",
    commission: "₹800.00",
    rate: "10%",
    status: "Partial",
    date: "1/28/2024",
    remaining: "₹400.00",
  },
  {
    id: 4,
    policy: "POL001237",
    customer: "Alice Brown",
    type: "Travel Insurance",
    premium: "₹5,000.00",
    commission: "₹500.00",
    rate: "10%",
    status: "Paid",
    date: "1/20/2024",
    remaining: "-",
  },
];

export default function PayoutTable() {
  return (
    <Box sx={{ height: 360, width: "100%", mt: 2 }}>
      <DataGrid
        columns={columns}
        rows={rows}
        hideFooter
        disableColumnMenu
        autoHeight={false}
        sx={{
          border: "none",
          "& .MuiDataGrid-cell": { borderBottom: 0 },
          "& .MuiDataGrid-columnHeaders": { backgroundColor: "#ffffff" },
        }}
      />
    </Box>
  );
}
